import React from 'react';
import './TravelInsurance.css';

const travelinsurance = () => {
  return (
    <div>
      <div className='privacy-policy-container'>
      <div className='privacy-policy-subtitle'>TRAVEL VALIDITY</div>
      <div className='privacy-policy-list'>
        <ul>
          <li>Race against the best on the virtual reality experience. Take your place in the spotlight.</li>
          <li>Race against the best on the virtual reality experience. Take your place in the spotlight.</li>
        </ul>
      </div>
      </div>

      <div className='privacy-policy-container'>
      <div className='privacy-policy-subtitle'>TRAVEL VALIDITY</div>
      <div className='privacy-policy-list'>
        <ul>
          <li>Race against the best on the virtual reality experience. Take your place in the spotlight.</li>
        </ul>
      </div>
      </div>
      <div className='privacy-policy-container'>
      <div className='privacy-policy-subtitle'>TRAVEL VALIDITY</div>
      <div className='privacy-policy-list'>
        <ul>
          <li>Race against the best on the virtual reality experience. Take your place in the spotlight.</li>
          <li>Race against the best on the virtual reality experience. Take your place in the spotlight.</li>
        </ul>
      </div>
    </div>
    </div>
  );
};

export default travelinsurance;
